const publicBaseUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL.replace(/\/$/, '') : '';
const withBase = (path) => `${publicBaseUrl}${path}`;

export const deck2029 = {
  id: '2029',
  title: '2029 Predictions',
  assetsBaseUrl: withBase('/predictions_assets/2029/'),
  gridTakeoverStatements: [
    { text: 'STUDIOS ARE TOTAL INSTITUTIONS', type: 'doom' },
    { text: 'THE FREELANCE LIFESTYLE IS OVER', type: 'doom' },
    { text: 'SHADOW VFX BUNKER', type: 'doom' },
    { text: 'SYNTH WATERMARK REQUIRED', type: 'doom' },
    { text: "RUNNERS CAN'T AFFORD WORK", type: 'doom' },
    { text: 'AUTHENTICITY NOW MANDATORY', type: 'doom' },
    { text: 'INEFFICIENCY IS BANKABLE', type: 'doom' },
    { text: 'THE GATES STAYED OPEN', type: 'hope' },
    { text: '680 UNITS BUILT', type: 'hope' },
    { text: 'GEOGRAPHIC MOBILITY RESTORED', type: 'hope' },
    { text: 'COMPANY TOWN AVOIDED', type: 'hope' },
    { text: 'MOBILITY INCREASED TO 18%', type: 'hope' },
    { text: 'FREELANCE CAREERS VIABLE', type: 'hope' },
    { text: 'HOUSING INTERVENTION WORKED', type: 'hope' },
    { text: 'REGIONAL PRODUCTION THRIVING', type: 'hope' },
    { text: 'CREW SHELTER PROGRAM SUCCESS', type: 'hope' },
    { text: 'AUTHENTIC CONTENT PREMIUM', type: 'hope' }
  ],
  dataUrls: {
    data: withBase('/data/2029_predictions/data.json'),
    countermeasures: withBase('/data/2029_predictions/countermeasures.json'),
    templateSequence: withBase('/data/2029_predictions/templateSequence.json'),
    pixelPresets: withBase('/data/2029_predictions/pixelPresets.json')
  }
};
